<script>
import Translatable from '@src/mixins/translatable.js'

export default {
  mixins: [
    Translatable
  ],
  props: {
    object: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      transport: {
        metro: this.object.metro,
        tram: this.object.tram,
        bus: this.object.bus,
        funicular: this.object.funicular,
        ferry: this.object.ferry,
        parking: this.object.content.en.parking
      }
    }
  },
  computed: {
    availableTransport() {
      return Object.keys(this.transport).filter(transportType => {
        return this.transport[transportType] && this.transport[transportType] !== ''
      })
    }
  },
  methods: {
    transportLabel(transport) {
      return this.getTranslatedContent(`${transport.toUpperCase()}`)
    }
  },
}
</script>

<template>
  <div class="info-list">
    <h5>{{ getTranslatedContent('AREA_info_how_to_get').replace( "$name", getTranslatedContent('title', object.content)) }}</h5>
    <div v-if="availableTransport.length" class="list-item transport-info">
      <i class="metro-icon"></i>
      <div class="transport-data">
        <div
          v-for="(transportType, index) in availableTransport"
          :key="index"
          class="transport-row"
        >
          <p class="transport-type">{{ transportLabel(transportType) }}</p>
          <p class="transport-type-data">{{ transport[transportType] }}</p>
        </div>
      </div>
    </div>
    <p class="app-tip">
      {{ getTranslatedContent('AREA_info_navigate_to').replace( "$to", getTranslatedContent('title', object.content)) }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.info-list {
  margin: 30px;

  h5 {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    color: #FFFFFF;

    margin-top: 35px;
  }

  .app-tip {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;

    /* white */

    color: #FFFFFF;
    width: 313px;
    margin-top: 39px;
  }
}

.list-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  & i {
    width: 43px;
    height: 43px;
  }

  & .metro-icon {
    background: url("../../assets/icons/underground.svg") center no-repeat;
    margin-top: -25px;
  }

  &.transport-info {
    margin-top: 20px;

    .transport-data {
      margin-left: 14px;

      .transport-row {
        display: flex;
        flex-direction: row;
        margin-bottom: 5px;

        .transport-type {
          font-family: Open Sans Bold, sans-serif;
          font-style: normal;
          font-weight: bold;
          font-size: 12px;
          line-height: 16px;
          min-width: 56px;
          text-transform: uppercase;
          color: #FFFFFF;
          margin-right: 10px;
        }

        .transport-type-data {
          font-family: Open Sans, sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 16px;
          text-transform: uppercase;
          color: #FFFFFF;
          // width: 100%;
          word-break: break-word;
        }
      }
    }
  }
}
</style>
